module.exports = __webpack_public_path__ + "img/8.458e08df.png";